import { File, FileImage, FileText, FileType2 } from 'lucide-react';

/** A row identifies its file type; opening it still shows the full document. */
export function LibraryFileIcon({ mime }: { mime: string }) {
  const Icon = mime === 'application/pdf'
    ? FileText
    : mime.startsWith('image/')
      ? FileImage
      : mime === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || mime === 'application/msword'
        ? FileType2
        : File;

  return (
    <span aria-hidden="true" className="h-10 w-10 shrink-0 rounded-lg bg-muted flex items-center justify-center text-muted-foreground">
      <Icon className="h-5 w-5" />
    </span>
  );
}
